import React, {useState} from 'react';
import {Typography, Button, Divider} from "@material-ui/core";
import {makeStyles, createStyles} from "@material-ui/core/styles";
import {ArrowDropDown} from "@material-ui/icons";
import SelectLineModal from "../../../modals/SelectLineModal";
import SelectProductModal from "../../../modals/SelectProductModal";
import {disableFutureDates} from "../../DateTimeHelperUtils";
import {DatePicker} from "@material-ui/pickers";
import colorPalette from '../../../Palette';
import MultiDatesPicker from '../../../modals/MultiDatesPicker';
import Filter from '../../Filter';
import FilterDropdown from '../../FilterDropdown';
import moment from 'moment';
import { CircularProgress } from '@mui/material';

export default function TrendReportTitleAndOptions(props) {
    const classes = useStyles();
    const [showSelectLines, setShowSelectLines] = useState(false);
    const [showSelectShifts, setShowSelectShifts] = useState(false);
    const [showSelectGranularity, setShowSelectGranularity] = useState(false);
    const [moreFilters, setMoreFilters] = useState(false);
    const [wasChange, setWasChange] = useState(false);
    const [openDates, setOpenDates] = useState(false);

    const currentDate = moment.utc().format('YYYY-MM-DD');

    const showSelectDates = () => {
        const selectedArray = []
        const monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"]; 
        if (props.date_from && props.date_to) {
            const dayFrom = props.date_from.getDate();
            const monthFromIndex = props.date_from.getMonth();
            const monthFromName = monthNames[monthFromIndex];
            const yearFrom = props.date_from.getFullYear();

            selectedArray.push(`${dayFrom} ${monthFromName} ${yearFrom}`)

            const dayTo = props.date_to.getDate();
            const monthToIndex = props.date_to.getMonth();
            const monthToName = monthNames[monthToIndex];
            const yearTo = props.date_to.getFullYear();

            selectedArray.push(`${dayTo} ${monthToName} ${yearTo}`)
        }

        return (
            <div style={{ marginRight: '36px', padding: '0px 0 0px 0px', float: 'left' }}>
                <Filter onClick={() => openFilter("dates")} title={`Dates`} type={"rangeDate"} selectedArray={selectedArray.length > 0 ? selectedArray : ["", ""]} isOpen={props.show_select_dates}  />
            </div>


        );
    };

    const openFilter = (filter) => {
        let granularity = false;
        let lines = false;
        let shifts = false;
        let dates = false;
        switch (filter) {
            case 'lines':
                lines = !showSelectLines;
                break;
            case 'shifts':
                shifts = !showSelectShifts;
                break;
            case 'granularity':
                granularity = !showSelectGranularity;
                break;
            case 'dates':
                dates = !openDates;
                break;
            default:
                break;
        }
        setOpenDates(dates);
        setShowSelectLines(lines);
        setShowSelectShifts(shifts);
        setShowSelectGranularity(granularity);
    }

    const showDatesModal = () => {
        return (
            openDates && (
                <MultiDatesPicker
                    // setReportMultipleDates={props.setReportMultipleDates}
                    setReportRangeDates={(date_from, date_to) => { props.setReportRangeDates(date_from, date_to); openFilter("dates") }}
                    type={'range'}
                    from={props.date_from}
                    to={props.date_to}
                    handleClose={() => openFilter("dates")}
                    onlyRange={true}
                    suggestions={true}
                    start_day_of_week={props.start_day_of_week}
                />
            )
        );
    };

    const showGranularity = () => {
        return (
            <div style={{ marginRight: '36px', padding: '0px 0 0px 0px', float: 'left', position: "relative" }}>
                <Filter onClick={() => openFilter("granularity")} title={`Granularity`} type={"text"} displayAll={false} selectedArray={props.selectedGranularity} isOpen={showSelectGranularity}  />
                {showSelectGranularity && (
                    <div style={{ position: "absolute", left: "0px", marginTop: "10px", zIndex: "100" }}>
                        <FilterDropdown radio title={"Granularity Filter"} items={[ {name: 'Day', id: 1 }, {name: 'Week', id: 2 }, {name: 'Month', id: 3 },]} selectedItems={props.selectedGranularity} onSave={(selected_granularity) => { openFilter("granularity"); props.handleSelectGranularity(selected_granularity) }} onClose={() => openFilter("granularity")} />   
                    </div>
                )}
            </div>
        );
    };

    const showLines = () => {
        if (props.lines == null || props.lines.length === 0) {
            return <div>
                {/* Loading... */}
            </div>;
        }

        let count = '0';

        if (props.selected_lines && props.lines[0])
            if (props.selected_lines.length === props.lines.length) {
                count = 'All';
            } else {
                count = props.selected_lines.length.toString();
            }

        let selectedArray = []
        
        if (_.isEmpty(props.lines)) {
            selectedArray = [{name: " "}]
        }
        else {
            props.selected_lines.forEach((item) => {
                const line = props.lines.find((line) => line.id === item)
                if (line) {
                    selectedArray.push({ name: line.name, id: line.id })
                }
            })
        }

        let totalArray = []

        if (props.lines && props.lines[0]) {
            props.lines.forEach((item) => {
                totalArray.push({ name: item.name, id: item.id })
            })
        }


        return (
            <div style={{ marginRight: '36px', padding: '0px 0 0px 0px', float: 'left', position: "relative" }}>
                <Filter onClick={() => openFilter("lines")} title={`Lines`} type={"text"} displayAll={count === "All"} selectedArray={selectedArray} isOpen={showSelectLines}  />
                {showSelectLines && (
                    <div style={{ position: "absolute", left: "0px", marginTop: "10px", zIndex: "100" }}>
                        <FilterDropdown title={"Line Filter"} items={totalArray} selectedItems={selectedArray} onSave={(selected_lines) => { openFilter("lines"); props.handleSelectLines(selected_lines) }} onClose={() => openFilter("lines")} />   
                    </div>
                )}
            </div>
        );
    };

    const showShifts = () => {

        if (props.shifts == null && props.selectedShifts == null) {
            return <div></div>;
        }

        let count = '0';

        if (props.selectedShifts && props.shifts && props.shifts[0]) {
            if (props.selectedShifts.length === props.shifts.length) {
                count = 'All';
            } else {
                count = props.selectedShifts.length.toString();
            }
        }
        else {
            count = '0'
        }

        let selectedArray = []

        props.selectedShifts.forEach((shift) => {
            if (shift.start_time && shift.end_time) {
                selectedArray.push({ name: `${shift.name} ${moment(`${currentDate} ${shift.start_time}`).format('LT')} - ${moment(`${currentDate} ${shift.end_time}`).format('LT')}`, id: shift.id })
            }
            else {
                selectedArray.push({ name: `${shift.name}`, id: shift.id })
            }
        })

        let totalArray = []

        if (props.shifts && props.shifts[0]) {
            props.shifts.forEach((shift) => {
                totalArray.push({ name: `${shift.name} ${moment(`${currentDate} ${shift.start_time}`).format('LT')} - ${moment(`${currentDate} ${shift.end_time}`).format('LT')}`, id: shift.id })
            })
        }

        //shifts
        //selectedShits
        //usesShifts

        return (
            <>
                {props.usesShifts ? (
                    <div style={{ marginRight: '36px', padding: '0px 0 0px 0px', float: 'left', position: "relative" }}>
                        <Filter onClick={() => openFilter("shifts") } title={`Shifts`} type={"text"} displayAll={count === "All"} selectedArray={selectedArray} isOpen={props.show_select_shifts}  />
                            {showSelectShifts && (
                                <div style={{ position: "absolute", left: "0px", marginTop: "10px", zIndex: "100" }}>
                                    <FilterDropdown allowNoItems title={"Shifts Filter"} items={totalArray} selectedItems={selectedArray} onSave={(array) => { props.handleSelectShifts(array); openFilter("shifts") }} onClose={() => openFilter("shifts")} />   
                                </div>
                        )}
                    </div>
                ) : null}
            </>
        );
    }


    return <div className={props.collapse ? classes.card_collapse : classes.card}>
        <div className={classes.title_div}>
            <Typography style={{ fontWeight: "500", fontSize: `28px)` }} variant="h5" className={classes.title}>Trend Report</Typography>
        </div>
        <hr style={{ margin: "24px -30px 0px -30px", borderTop: "1px solid #E3E7ED" }} />
        <div className={classes.options_div} style={{ width: "100%" }}>
            <div className={classes.options_selectors} style={{ width: "100%" }}>
                <div className={classes.lines_products_div} style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "32px", marginRight: "0px", marginBottom: "0px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {showSelectDates()}
                        {showGranularity()}
                    </div>
                    <div>
                        <Button
                            style={{
                                marginTop: '0px',
                                marginRight: `24px`,
                                height: `42px`,
                                width: `120px`,
                                fontSize: `14px`,
                                textTransform: 'none'
                            }}
                            variant={'outlined'}
                            color={'primary'}
                            onClick={() => { setMoreFilters(!moreFilters); setShowSelectLines(false); setShowSelectShifts(false); setShowSelectGranularity(false); setOpenDates(false) } }
                        >
                            {moreFilters ? 'Less Filters' : 'More Filters'}
                        </Button>
                        <Button
                            style={{
                                marginTop: '0px',
                                height: `42px`,
                                width: `120px`,
                                fontSize: `14px`,
                                textTransform: 'none'
                            }}
                            variant={'contained'}
                            color={'primary'}
                            disabled={props.applyDisabled}
                            onClick={props.getReport}
                        >
                            {props.loading ? (
                                <CircularProgress sx={{ color: "white" }} size={24} />
                            ) : (
                                <p>Apply Filters</p>
                            )}
                        </Button>
                    </div>
                </div >
            </div>
            {moreFilters ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "24px" }}>
                    {showLines()}
                    {showShifts()}
                </div>
            ) : null}
        </div>
        {showDatesModal()}
    </div>
}


const useStyles = makeStyles((theme) => createStyles({
    card: {
        width: 'calc(100%)',
        // margin: '20px 20px 0px 176px',
        padding: "30px",
        boxSizing: 'border-box',
        background: 'transparent',
        // boxShadow: '0px 0px 8px rgba(0,0,0,0.3)',
        position: 'relative',
        transition: 'all 195ms ease-in-out',
        display: 'inline-block'
    },
    card_collapse: {
        width: 'calc(100%)',
        // margin: '20px 0px 0px 56px',
        padding: "30px",
        boxSizing: 'border-box',
        background: 'transparent',
        // boxShadow: '0px 0px 8px rgba(0,0,0,0.3)',
        position: 'relative',
        transition: 'all 195ms ease-in-out',
        display: 'inline-block'
    },
    title_div: {
        background: 'transparent',
        // padding: '30px'
    },
    title: {
        fontWeight: '600',
        fontSize: "32px",
        color: colorPalette.neutral[100]
    },
    options_div: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
    },
    options_selectors: {
        display: 'flex',
        flexDirection: 'row'
    },
    options_buttons : {
        margin: '30px 0',
        display: 'flex',
        alignItems: 'center'
    },
    lines_products_div: {
        margin: '15px 30px 15px 0',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'baseline'
    },
    date_pickers_div: {
        margin: '15px 30px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'baseline'
    },
    button: {
        marginBottom: '4px'
    },
    option_item: {
        fontSize: '16px !important',
        marginRight: '10px !important',
        marginTop: '12px !important',
        textAlign: 'start !important',
        textTransform: 'capitalize !important'
    },
    option_item_dropdown: {
        justifyContent: 'start',
        fontSize: '16px !important',
        marginRight: '10px !important',
        marginTop: '12px !important',
        textAlign: 'start !important',
        textTransform: 'capitalize !important'
    },
    option_item_date: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '16px !important',
        marginRight: '10px !important',
        marginTop: '12px !important',
        textAlign: 'start !important',
        textTransform: 'capitalize !important'
    }
}))